module.exports = require("@pb/kit-hooks-use-component-did-update");